import React, { useCallback, useMemo } from 'react'
import { DialogField } from 'view/components/inputs'
import { PreparedOrderClearingDetail } from 'api'
import { ClearingHouseSelectboxField } from 'view/shared/entity'
import { Locale, Translation } from 'locale'
import { sortBy } from 'lodash-es'

interface DirectClearingSectionProps {
  readOnly: boolean
  clearingHouseId: string | null
  preparedOrderClearingDetails: PreparedOrderClearingDetail[]
  onChangeClearingDetails: (clearingHouseId: string | null, sponsorId: string | null) => unknown
}

export const DirectClearingSection: React.FunctionComponent<DirectClearingSectionProps> = props => {
  const { readOnly, preparedOrderClearingDetails, clearingHouseId, onChangeClearingDetails } = props

  const onUpdateClearingHouseId = useCallback(
    (newClearingHouseId: string | null) => {
      if (newClearingHouseId !== clearingHouseId) {
        onChangeClearingDetails(newClearingHouseId, null)
      }
    },
    [clearingHouseId, onChangeClearingDetails]
  )

  const clearingHouseIds = useMemo(() => {
    const filteredDetails = preparedOrderClearingDetails.filter(preparedOrderClearingDetail => preparedOrderClearingDetail.sponsor === null)

    return sortBy(filteredDetails, detail => detail.clearingHouse!.publishedName).map(detail => detail.clearingHouse!.id)
  }, [preparedOrderClearingDetails])

  return (
    <DialogField>
      <ClearingHouseSelectboxField
        dataTestId={'DirectClearingSection-ClearingHouseSelectboxField-CCP'}
        readOnly={readOnly}
        label={Locale.translate(Translation.TC_CCP)}
        optionKeys={clearingHouseIds}
        value={clearingHouseId}
        onUpdate={onUpdateClearingHouseId}
      />
    </DialogField>
  )
}
